import { apiSlice } from "./apiSlice"
import { apiRoutes } from "../../config/api"

export const referenceStockService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        addTagsToReferenceStock: builder.mutation({
            query: (body: {
                processId: string,
                siteId: string,
                zoneId: string,
                userId: string,
                tags: Array<{
                    epc: string,
                    upc?: string,
                    tagId?: string,
                    productDescription?: string
                }>
            }) => ({
                url: apiRoutes.ADD_REFERENCE_STOCK_TAGS,
                method: "POST",
                body: body,
            }),
        }),
        deleteTagsFromReferenceStock: builder.mutation({
            query: (body: {
                processId: string,
                siteId: string,
                zoneId: string,
                userId: string,
                tags?: Array<{
                    epc: string,
                    tagId?: string
                }>,
                deleteAll?: boolean
            }) => ({
                url: apiRoutes.DELETE_REFERENCE_STOCK_TAGS,
                method: "DELETE",
                body: body,
            }),
        }),
        getReferenceStock: builder.query({
            query: (params: {
                processId: string,
                siteId: string,
                zoneId: string
            }) => ({
                url: `${apiRoutes.GET_REFERENCE_STOCK}/${params.processId}/${params.siteId}/${params.zoneId}`,
                method: "GET",
            }),
        }),
    })
})

export const {
    useAddTagsToReferenceStockMutation,
    useDeleteTagsFromReferenceStockMutation,
    useGetReferenceStockQuery,
    useLazyGetReferenceStockQuery
} = referenceStockService


